import React from "react";
import { Star } from "lucide-react";
import { siteFacts } from "@/lib/site-data";

export function GoogleIcon() {
  return (
    <svg
      className="google-g-icon"
      width="25"
      height="25"
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.61l6.85-6.85C35.9 2.38 30.49 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.2C12.43 13.72 17.74 9.5 24 9.5Z"
      />
      <path
        fill="#4285F4"
        d="M46.5 24.55c0-1.64-.15-3.22-.43-4.73H24v8.95h12.61c-.54 2.88-2.16 5.32-4.61 6.96v5.84h7.47c4.37-4.03 6.9-9.96 6.9-17.02Z"
      />
      <path
        fill="#FBBC05"
        d="M10.54 28.58a14.49 14.49 0 0 1 0-9.16v-6.2H2.56A23.99 23.99 0 0 0 0 24c0 3.87.93 7.53 2.56 10.78l7.98-6.2Z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.92-2.14 15.89-5.82L32.42 36.34c-2.14 1.44-4.87 2.29-8.42 2.29-6.26 0-11.57-4.22-13.46-9.91l-7.98 6.2C6.51 42.62 14.62 48 24 48Z"
      />
    </svg>
  );
}

function Stars() {
  return (
    <span className="google-rating-stars" aria-hidden="true">
      {Array.from({ length: 5 }, (_, index) => (
        <Star key={index} size={17} fill="currentColor" />
      ))}
    </span>
  );
}

export function GoogleRatingBadge({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <a
        className="google-rating-badge google-rating-badge-compact"
        href="/#opinie"
        aria-label="Przejdź do opinii Klientów w Google"
      >
        <GoogleIcon />
        <strong className="google-rating-compact-score">5,0</strong>
        <Stars />
        <span className="google-rating-compact-text">249 opinii</span>
      </a>
    );
  }

  return (
    <a
      className="google-rating-badge"
      href="/#opinie"
      aria-label="Przejdź do opinii Klientów w Google"
    >
      <GoogleIcon />
      <div className="google-rating-copy">
        <div className="google-rating-summary">
          <strong>5,0</strong>
          <Stars />
          <span>249 opinii</span>
        </div>
        <span>Opinie z wizytówek Google</span>
      </div>
    </a>
  );
}
